// const urlStart = 'http://localhost:8000'
var environment = 'production'
var serverUrl = 'https://mon.qtrust.id:40013';
var serviceName = 'asmoid-dashboard';
var secretToken = 'PpUw5ZibLVZFORV';
const gaId = 'G-DFN8MT1GB4';
const urlStart = 'https://asmoid-dash.qtrust.id/'

export default { environment , gaId , serverUrl , serviceName , secretToken , urlStart }
